import Box from './src/Box.vue'

Box.install = function(Vue) {
    Vue.component(Box.name, Box)
}

export default Box